import { PageLayout } from '@kizi/comparator-core';

const steps = [{ title: 'Vergelijken' }];

const productComparisonLayout: PageLayout = {
  name: 'productComparison',
  components: [
    {
      type: 'ComparisonPage',
      props: {
        comparisonProducts: 'overview.comparisonProducts',
        contentStyles: {
          span: [12, 12, 12, 12],
        },
        bg: 'second.2',
        header: [
          {
            type: 'PageHeader',
            props: {
              steps,
              activeStep: 0,
            },
          },
        ],
        subHeader: [
          {
            type: 'Heading',
            props: {
              variant: 'H2',
              as: 'h2',
              children: 'Vergelijken',
            },
          },
          {
            type: 'GoToButtonIcon',
            props: {
              variant: 'transparentWithIcon',
              index: 1,
              children: 'Terug naar overzicht',
            },
          },
        ],
        content: [
          {
            type: 'ExperienceManager',
            props: {
              label: 'Draai je telefoon voor een betere ervaring',
            },
            _children: [
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  labels: [
                    {
                      label: '',
                    },
                    {
                      label: '',
                    },
                    {
                      label: '',
                    },
                    {
                      label: '',
                    },
                    {
                      label: '',
                    },
                    {
                      label: '',
                    },
                    {
                      label: '',
                    },
                  ],
                  comparator: 'os-triple-play',
                  section: 'overview',
                  goToIndex: 2,
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Contract',
                  labels: [
                    {
                      label: 'Looptijd',
                    },
                    {
                      label: 'Levertijd',
                    },
                    {
                      label: 'Overstapservice',
                      tooltip:
                        'De nieuwe aanbieder regelt de opzegging met de oude aanbieder.',
                    },
                    {
                      label: 'Installatie opties',
                      tooltip: 'De optie tot een monteur.',
                    },
                  ],
                  comparator: 'os-triple-play',
                  section: 'costs',
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Internet',
                  labels: [
                    {
                      label: 'Downloadsnelheid',
                    },
                    {
                      label: 'Uploadsnelheid',
                    },
                    {
                      label: 'Netwerk',
                    },
                    // {
                    //   label: 'WiFi check',
                    // },
                  ],
                  comparator: 'os-triple-play',
                  section: 'internetPackages',
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Televisie',
                  labels: [
                    {
                      label: 'TV Zenders',
                    },
                    {
                      label: 'HD Zenders',
                      tooltip: 'Het aantal hd-tv-zenders bij dit product',
                    },
                    {
                      label: 'TV via app',
                    },
                    {
                      label: 'Terugkijken en pauzeren',
                      tooltip:
                        'De mogelijkheid om terug te kijken en te pauzeren.',
                    },
                  ],
                  comparator: 'os-triple-play',
                  section: 'televisionPackages',
                  dependsOn: {
                    dependenceProperty: 'productTypes',
                    dependenceValue: 'television',
                  },
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Bellen',
                  labels: [
                    {
                      label: 'Onbeperkt bellen NL',
                    },
                    {
                      label: 'Onbeperkt bellen EU',
                    },
                    {
                      label: 'Nummerbehoud',
                    },
                  ],
                  comparator: 'os-triple-play',
                  section: 'callPackages',
                  dependsOn: {
                    dependenceProperty: 'productTypes',
                    dependenceValue: 'call',
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
};

export default productComparisonLayout;
